<template>
  <main>
    <tab-bulletin-board-header />
      <div class="tab-content">
        <div class="tab-pane active show">
          <release-notice
          />
        </div>
      </div>
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'

import TabBulletinBoardHeader from './components/TabBulletinBoardHeader'
import ReleaseNotice from './components/ReleaseNotice'

import { debuglog } from 'util';

export default {
  name: 'BulletinBoardTab2',
  mixins: [commonMixin],
  components: {
    TabBulletinBoardHeader, ReleaseNotice
  },
  computed: {
    ...mapGetters([
      
    ])
  },
  data () {
    return {
      order: {
          index: 1,
          asc: true
      },
      status: 'STATUS_UNIT_CONDITION',
      checkModalOpen: false,
      reasonType: 1,
      transferModalOpen: false,
      tableData: [
          {

          }
      ],
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    setSelectedItem: function(selectedItem, status, title) {
      this.formSelectItem = selectedItem;
      this.status = status;
      this.condition_title = title
    },
    goReleaseTable(title) {
      this.status = 'STATUS_RELEASE_TABLE';
      this.condition_title = title;
    },
    resetSelectedItem(reset) {
      this.formSelectItem = reset;
    },
    returnUnitCondition () {
      this.status = 'STATUS_UNIT_CONDITION'
    }
  },
  beforeMount () {
  },
  mounted () {
      
  }
}
</script>
